module.exports = __webpack_public_path__ + "assets/media/member-bg.f76384e4.png";